import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import {
    HttpClient,
    HttpErrorResponse,
    HttpHeaders,
    HttpParams,
} from '@angular/common/http';
import { TokenService } from '../services/token.service';
import { LoginResponse } from '../response/login-response';
import { environment } from 'src/environments/environment';
import { ServiceBase } from '@core/services/service-base';
import { CodesaResponseData } from '@core/response/codesa-reponse-data';

const service = "authService";
const OAUTH_CLIENT = 'devglan-client';
const OAUTH_SECRET = 'devglan-secret';
const HTTP_OPTIONS = {
    headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Basic ' + btoa(OAUTH_CLIENT + ':' + OAUTH_SECRET),
    }),
};

@Injectable({
    providedIn: 'root',
})
export class LoginService extends ServiceBase {
    private grant_type = 'password';
    redirectUrl = '';
    private static handleError(error: HttpErrorResponse): any {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        } else {
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        return throwError(
            'Something bad happened; please try again later.');
    }

    private static log(message: string): any {
        console.log(message);
    }

    constructor(private http: HttpClient, private tokenService: TokenService) {
        super(service);
    }

    login(username: string, password: string): Promise<CodesaResponseData<LoginResponse>> {
        return this.http.post<CodesaResponseData<LoginResponse>>(this.url + '/oauth/token', {
            username: username,
            password: password
        },
        ).toPromise();
    }

    refreshToken(refreshData: any): Observable<any> {
        this.tokenService.removeTokenSession();
        const body = new HttpParams()
            .set('refresh_token', refreshData.refresh_token)
            .set('grant_type', 'refresh_token');
        return this.http
            .post<any>(this.url + 'oauth/token', body, HTTP_OPTIONS)
            .pipe(
                tap((res) => {
                    this.tokenService.saveToken(res.access_token);
                }),
                catchError(LoginService.handleError)
            );
    }
}
